import { ArrowRight, Mail } from "lucide-react";
import { useScrollReveal } from "../../hooks/useScrollReveal";

export const GetStarted = () => {
  const [ref, vis] = useScrollReveal();

  return (
    <section
      id="get-started"
      data-testid="get-started-section"
      className="bg-[#0F172A] py-28 md:py-40 lg:py-48 relative overflow-hidden"
    >
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#0064E0] opacity-[0.04] blur-[120px] pointer-events-none" />

      <div ref={ref} className={`relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 reveal ${vis ? 'visible' : ''}`}>
        <div className="max-w-[680px] mx-auto text-center">
          <div className="editorial-rule mx-auto mb-6" />

          <h2
            data-testid="get-started-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(28px,3.5vw,48px)] tracking-[-0.03em] text-white leading-[1.0]"
          >
            Let's find out if we're a fit.
          </h2>

          <div className="mt-10 md:mt-12 space-y-5">
            <p className="text-[17px] md:text-[18px] leading-[1.7] text-[#94A3B8]">
              Book a 30-minute call. We will look at your ads and your
              funnel, then tell you plainly whether we can help and what
              we would change first. No deck, no pitch.
            </p>
          </div>

          <div className="mt-12 md:mt-16">
            <a
              href=""
              onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
              data-testid="get-started-cta-button"
              className="calendly-cta btn-primary inline-flex items-center justify-center gap-3 bg-[#0064E0] text-white rounded-xl px-12 py-5 text-[18px] font-medium hover:bg-[#3B8EFF] focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2 focus:ring-offset-[#0F172A] w-full sm:w-auto"
            >
              See If We're a Fit
              <ArrowRight className="arrow-icon w-5 h-5" />
            </a>
          </div>

          <p
            data-testid="get-started-supporting-line"
            className="mt-6 text-[14px] text-[#64748B]"
          >
            30 minutes. No deck. We look at your account and tell you whether we can help.
          </p>

          <div className="mt-12 w-12 h-px bg-[#1E293B] mx-auto" />

          <div className="mt-8 flex items-center justify-center gap-2 text-[14px] text-[#64748B]">
            <Mail className="w-4 h-4 text-[#0064E0]" strokeWidth={1.5} />
            <span>
              Or email us directly:{" "}
              <a
                href="mailto:marketing@bldventuresgroup.com"
                data-testid="contact-email-link"
                className="text-[#0064E0] hover:text-[#3B8EFF] underline underline-offset-4 decoration-[#0064E0]/30 hover:decoration-[#0064E0] transition-colors"
              >
                marketing@bldventuresgroup.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
